import { ConditionTypeDetailsProps } from "@redotech/redo-return-ui/flows/return-flow/condition";
import { CustomerTagState } from "@redotech/redo-return-ui/flows/return-flow/condition-types/customer-tag";
import { RedoTagInputField } from "@redotech/redo-web/arbiter-components/input/redo-tag-input-field";
import { memo, useMemo, useState } from "react";

export const CustomerTagDetails = memo(function CustomerTagDetails({
  state,
  setState,
  disabled,
}: ConditionTypeDetailsProps<CustomerTagState>) {
  const [inputValue, setInputValue] = useState("");

  const tags = useMemo(
    () => state.map((tag) => ({ text: tag, color: "gray" as const })),
    [state],
  );

  return (
    <RedoTagInputField
      delimiters={["newline"]}
      inputValue={inputValue}
      label="Customer tags"
      placeholder="Type and press Enter to add tags"
      setInputValue={setInputValue}
      setTags={setState}
      size="sm"
      state={disabled ? "disabled" : "default"}
      tags={tags}
    />
  );
});
